import { format } from 'date-fns';
import { TableColumn } from '../components/ui/Table';
import { User, UserTable } from '../models/user';

const UsersColumns: TableColumn<UserTable>[] = [
  { id: 'id', label: 'ID' },
  { id: 'name', label: 'Name' },
  { id: 'status', label: 'Status' },
  { id: 'bookings', label: 'Bookings' },
  { id: 'sportyPoint', label: 'Sporty Points' },
  { id: 'moneySpent', label: 'Money Spent' },
  { id: 'createdAt', label: 'Date' },
];

const getTableHeader = (readOnly: boolean) => {
  const columns = UsersColumns;
  return readOnly
    ? columns
    : ([
        ...columns,
        { id: 'actions', label: 'Actions' },
      ] as TableColumn<UserTable>[]);
};

export const UsersToUserDataTable = (
  users: User[],
  readOnly = false,
  userRole: string,
) => {
  const data: UserTable[] = users.map(
    (
      {
        id,
        isVerified,
        firstName,
        lastName,
        fullName,
        email,
        providerVerified,
        userIdVerification,
        isVerificationBadgeEligible,
        sportypoint,
        bookingCountProvider,
        hasActiveBooking,
        hasUpcomingBooking,
        isBanned,
        isOnline,
        isOrganization,
        organizationInfo,
        providerInfo,
        listCount,
        moneyEarn,
        moneySpent,
        userBooking,
        verifyShortNumberToken,
        updatePhone,
        twoFa,
        createdAt,
        updatedAt,
      },
      index,
    ) => {
      const values: UserTable = {
        id: id,
        serial: (index + 1).toString(),
        bookings: userBooking ? userBooking?.length?.toString() : '0',
        providerBookigns: bookingCountProvider,
        hasActiveBooking: hasActiveBooking,
        hasUpcomingBooking: hasUpcomingBooking,
        isBanned: isBanned,
        isOnline: isOnline,
        isOrganization: isOrganization,
        organizationInfo: organizationInfo,
        providerInfo: providerInfo,
        status: isBanned
          ? 'Banned'
          : userIdVerification != null
          ? userIdVerification?.status
          : 'Not Verified',
        name: fullName,
        firstName: firstName,
        lastName: lastName,
        email: email,
        isVerified: isVerified?.toString(),
        signUpOtp: verifyShortNumberToken ?? null,
        phoneUpdateOtp: updatePhone?.otp ?? null,
        twoFaOtp: twoFa?.otp ?? null,
        createdAt: format(
          createdAt ? new Date(createdAt) : new Date(),
          'MM-dd-yyy hh:mm a',
        ),
        updatedAt: format(
          updatedAt ? new Date(updatedAt) : new Date(),
          'MM-dd-yyy hh:mm a',
        ),
        sportyPoint: sportypoint?.toString(),
        moneySpent: moneySpent?.toString() || '0',
      };

      if (!readOnly) {
        values.actions = 'ACTIONS';
      }
      return values;
    },
  );
  return {
    headers: getTableHeader(readOnly),
    data,
  };
};
